export default __webpack_public_path__ + "static/media/mahindra.c754d513.png";